import { apiClient } from '../utils/api-client'
import type { TrainingSession } from '../types/training-session'
import type { Goal } from '../types/goal'
import type { Workout, WorkoutResult } from '../types/workout'
import type { WeeklyCheckIn, WeekSummary } from '../types/weekly-check-in'

export interface AttemptItem {
  climb_name: string
  climb_slug: string
  climb_type: string | null
  difficulty: string | null
  location_name: string | null
  location_slug: string | null
  location_type: string | null
  attempt_count: number
}

export interface DayAttempts {
  count: number
  items: AttemptItem[]
}

export type AscentSendType = 'on_sight' | 'flash' | 'worked' | 'nd'

export interface AscentItem {
  climb_name: string
  climb_slug: string
  climb_type: string | null
  difficulty: string | null
  location_name: string | null
  location_slug: string | null
  location_type: string | null
  send_type: AscentSendType | null
  attempts_count: number | null
  day_attempts_count: number
}

export interface WeekData {
  sessions: TrainingSession[]
  goals: Goal[]
  workouts: Workout[]
  workout_results?: WorkoutResult[]
  /** The week's own entry, when it has been written. */
  weekly_check_in?: WeeklyCheckIn | null
  week_summary?: WeekSummary
  attempts_by_date: Record<string, DayAttempts>
  ascents_by_date?: Record<string, AscentItem[]>
}

export interface CalendarDaySummary {
  session: boolean
  attempts: boolean
  goal: boolean
}

class TrainingDiaryService {
  async getWeek(from: string, to: string): Promise<WeekData> {
    const response = await apiClient.get(
      `/api/training_diary/week?from=${from}&to=${to}`,
      { requireAuth: true }
    )
    return response.json()
  }

  async getCalendarSummary(from: string, to: string): Promise<Record<string, CalendarDaySummary>> {
    const response = await apiClient.get(
      `/api/training_diary/calendar_summary?from=${from}&to=${to}`,
      { requireAuth: true }
    )
    return response.json()
  }
}

export const trainingDiaryService = new TrainingDiaryService()
